import { useEffect } from 'react';
import { useSettings } from './useSettings';

interface UseMetaTagsOptions {
  title?: string;
  description?: string;
  image?: string;
  pathname?: string;
}

export const useMetaTags = (options: UseMetaTagsOptions = {}) => {
  const { getSetting } = useSettings();

  useEffect(() => {
    // Get settings values
    let metaTitle = getSetting('meta_title', 'Album Digital');
    const metaDescription = getSetting('meta_description', 'Sube tus fotos al álbum compartido del evento');
    const metaImage = getSetting('meta_image', '');
    const metaFavicon = getSetting('meta_favicon', '');

    // Use page-specific values if provided, otherwise use settings
    const finalTitle = metaTitle || options.title || "Cargando...";
    const finalDescription = metaDescription || options.description;
    const finalImage = options.image || metaImage;

    // Update document title
    document.title = finalTitle;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, property?: string) => {
      if (!content) return;

      const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;

      if (!meta) {
        meta = document.createElement('meta');
        if (property) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }

      meta.setAttribute('content', content);
    };

    // Update favicon
    if (metaFavicon) {
      let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'icon');
        document.head.appendChild(favicon);
      }
      favicon.setAttribute('href', metaFavicon);
    }

    // Update meta tags
    updateMetaTag('description', finalDescription);
    updateMetaTag('og:title', finalTitle, 'og:title');
    updateMetaTag('og:description', finalDescription, 'og:description');
    updateMetaTag('twitter:title', finalTitle, 'twitter:title');
    updateMetaTag('twitter:description', finalDescription, 'twitter:description');

    if (finalImage) {
      updateMetaTag('og:image', finalImage, 'og:image');
      updateMetaTag('twitter:image', finalImage, 'twitter:image');
    }

    // Add other meta tags
    updateMetaTag('og:type', 'website', 'og:type');
    updateMetaTag('twitter:card', 'summary_large_image', 'twitter:card');

    if (options.pathname) {
      const currentUrl = `${window.location.origin}${options.pathname}`;
      updateMetaTag('og:url', currentUrl, 'og:url');
    }

  }, [getSetting, options.title, options.description, options.image, options.pathname]);
};